import {createAction} from "@reduxjs/toolkit";
import * as types from "../constants/ActionTypes";

export const deleteMyDealer = createAction(types.DELETE_MY_DEALER);
